import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { hasLegacyPermission } from '../utils/permissions';
import PageLoader from './PageLoader';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredPermission 
}) => {
  const { state } = useAuth();

  if (state.isLoading) {
    return <PageLoader fullScreen message="Verifying session..." />;
  }

  if (!state.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check for specific permission
  if (requiredPermission && state.user) {
    const hasPermission = hasLegacyPermission(state.user, requiredPermission);
    if (!hasPermission) {
      return (
        <Box 
          display="flex" 
          justifyContent="center" 
          alignItems="center" 
          minHeight="100vh"
          flexDirection="column"
        >
          <h2>Access Denied</h2>
          <p>You don't have permission to access this resource.</p>
        </Box>
      );
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
